import src from "IMAGE";
export default { src, width: 8, height: 8, blurWidth: 0, blurHeight: 0};
